import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleIcon, InfoIcon, MegaphoneIcon, WarningIcon, WrenchIcon } from '@phosphor-icons/react';

/** The icon of a sandbox admin message's kind (decorative: the text says the kind). */
export default function MessageIcon({ kind, status, size = 18 }) {
  const Icon = kind === 'maintenance' ? WrenchIcon
    : kind === 'incident' ? (status === 'resolved' ? CheckCircleIcon : WarningIcon)
      : kind === 'news' ? MegaphoneIcon : InfoIcon;
  return <Icon aria-hidden="true" size={size} />;
}

MessageIcon.propTypes = {
  kind: PropTypes.string,
  size: PropTypes.number,
  status: PropTypes.string,
};
